import React, { FunctionComponent } from 'react';
import { FullImage } from 'components/Images/FullImage';
import { ChannelBanned } from 'features/channel/components/ChannelBanned/ChannelBanned';
import styles from './styles.module.scss';
import { ThumbImage } from 'components/Images/ThumbImage';
import { OffAir } from 'components/OffAir';
import { LogoImage } from 'components/LogoImage';
import { FollowButtons } from 'features/chat/components/FollowButtons';
import { SupportButton } from 'components/Support/SupportButton';
import { useCurrentUser } from 'features/current-user/hooks';
import classNames from 'classnames';
import { Share } from 'components/Share';
import { useChannelEmbedNavigation } from 'features/events/EventEmbed/eventEmbedHooks';
import { Loader } from 'components/Loader';
import { useAppSelector } from 'hooks/redux';

export const ChannelEmbed: FunctionComponent = () => {
  const channel = useAppSelector((state) => state.channel.channelDetails);
  const channelisLoaded = useAppSelector((state) => state.channel.isLoaded);
  const artworkUrl = useAppSelector(
    (state) => state.channel.channelDetails?.channelArtwork.image.large || null
  );
  const embedPlayerLoaded = useAppSelector(
    (state) => state.channel.embedPlayerLoaded
  );
  const unavailable = useAppSelector(
    (state) => state.channel.channelUnavailable
  );
  const currentUser = useCurrentUser();

  useChannelEmbedNavigation();

  if (!channel) {
    return null;
  }

  const removeBranding = channel.removeEmbedBranding;

  if (unavailable || !channel.liveEmbedPlayerEnabled) {
    return <ChannelBanned />;
  }

  if (!channelisLoaded || channel == null || !embedPlayerLoaded) {
    return <Loader fillComponent={true} />;
  }

  return (
    <div
      className={classNames(styles['channel-embed'], {
        'has-image': channel.artworkKey
      })}
    >
      <FullImage
        artworkUrl={artworkUrl}
        artworkMode={'theme'}
        type={'event'}
        hideOverlay={true}
      />
      <div className={styles['channel-embed__content']}>
        <LogoImage
          size={'small'}
          hasFallback={!channel.logoKey}
          isLink={!removeBranding}
        >
          <ThumbImage
            artworkUrl={channel.channelLogo.image.small}
            artworkMode={'logo'}
            alt={`Logo for ${channel.username}`}
          />
        </LogoImage>
        <h1 className={styles['channel-embed__title']}>{channel.username}</h1>
        {removeBranding === false && (
          <>
            <div className={styles['channel-embed__links']}>
              <SupportButton showAslink />
              <FollowButtons
                showAslink
                selectedProfileId={channel.ownerId}
                followedIds={(currentUser && currentUser.followedUserIds) || []}
              />
            </div>
            <Share title={channel.username} label={''} showLabel={true} />
          </>
        )}
      </div>
      <OffAir />
    </div>
  );
};
